<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import type { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';
	import { getHeadlineUpdates } from '../../../services/teaser/HeadlineHelper.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';

	let { teaserContent, teaserType, enableSignupSheetMigration, teaserSize, teaserTouchPoint, showUpLogo }: {
		teaserContent: TeaserContent,
		teaserType: TeaserType,
		enableSignupSheetMigration: boolean,
		teaserSize: string,
		teaserTouchPoint: TeaserTouchPoint | undefined
		showUpLogo: boolean,
	} = $props();

	let headline = $state(teaserContent.heading);

	let teaser: Element;
	let trackingService: TrackingService;

	onMount(() => {
		trackingService = new TrackingService();
		watchForHeadlineUpdates();
		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});

	const watchForHeadlineUpdates = () => {
		const intervalId = window.setInterval(() => {
			if (teaserContent.countdown) {
				headline = getHeadlineUpdates(teaserContent.countdown, teaserContent.heading, teaserType, intervalId);
			}
		}, 1000);
	};
</script>
{#if !enableSignupSheetMigration}
	<div class="js_openInPaliSheet"
		bind:this={teaser}
		data-sheet-full-bleed-content="true"
		id="teaser-container"
		data-testid="up-teaser-s-container"
		data-sheet-id="{'teaser-' + teaserType}"
		data-sheet-title="{teaserContent?.sheetTitle}"
		data-sheet-url="{teaserContent.scarcity != null? teaserContent?.sheetUrl+'&scarcity='+teaserContent.scarcity : teaserContent?.sheetUrl}"
		onenterViewport={() => trackSeen(trackingService, teaser, teaserContent, teaserType, teaserSize)}
		use:onViewport
	>
		<div class="pl_media-object_wrapper">
			<div style="background-color: #e5e5e5" class="pl_media-object25">
				{#if showUpLogo}
					<div class="pl_media-object--image pl_media-object--icon">
						<svg style="fill: #f00020" class="pl_icon" id="pl_icon_otto-up" role="img">
							<use
								data-testid="pl_icon_otto-up"
								href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"
								xlink:href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"></use>
						</svg>
					</div>
				{/if}
				<div class="pl_media-object--content {showUpLogo ? '' : 'oc-mx-50'}" data-testid="headline">
					<div class="pl_media-object--headline">
						<div class="bold">{headline}</div>
					</div>
					<div class="pl_media-object--subline">{teaserContent?.subheading}</div>
				</div>
			</div>
		</div>
	</div>
{:else}
	<div
		bind:this={teaser}
		id="teaser-container"
		data-testid="up-teaser-s-container"
		data-oc-sheet-v1-create={JSON.stringify(toSignUpSheet(teaserType, teaserContent))}
		onenterViewport={() => trackSeen(trackingService, teaser, teaserContent, teaserType, teaserSize)}
		use:onViewport
	>
		<div class="pl_media-object_wrapper">
			<div style="background-color: #e5e5e5" class="pl_media-object25">
				{#if showUpLogo}
					<div class="pl_media-object--image pl_media-object--icon">
						<svg style="fill: #f00020" class="pl_icon" id="pl_icon_otto-up" role="img">
							<use
								data-testid="pl_icon_otto-up"
								href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"
								xlink:href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"></use>
						</svg>
					</div>
				{/if}
				<div class="pl_media-object--content {showUpLogo ? '' : 'oc-mx-50'}" data-testid="headline">
					<div class="pl_media-object--headline">
						<div class="bold">{headline}</div>
					</div>
					<div class="pl_media-object--subline">{teaserContent?.subheading}</div>
				</div>
			</div>
		</div>
	</div>
{/if}

<!--<style lang="scss">-->
<!--  @use "@otto-ec/design-tokens/tokens";-->

<!--  .up-teaser-grey-background {-->
<!--    background-color: tokens.$oc-base-color-gray-100;-->
<!--  }-->

<!--  .up_logo_red {-->
<!--    fill: tokens.$oc-base-color-otto-red-100;-->
<!--  }-->
<!--</style>-->
